// extracted by mini-css-extract-plugin
export default {"notFoundContainer":"NotFountPage_notFoundContainer__lLt2W","notFoundText":"NotFountPage_notFoundText__8KS76","homeLink":"NotFountPage_homeLink__K69zI"};